import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from 'semantic-ui-react';
import IOpenModalBtn from './IOpenModalBtn';

/** Open Modal Button
 * @param {string} title - Button title
 * @param {boolean} hide - hide the button
 * @link https://react.semantic-ui.com/elements/button/
 **/
const OpenModalButton: React.FC<IOpenModalBtn> = (props: IOpenModalBtn) => {

    const { t } = useTranslation();
    const { title, hidden=false, color, labelPosition, type, setOpen, ...rest} = props;

    if (hidden) return null;

    return (
        <Button
            icon
            className='extended-button'
            color={color ? color : undefined}
            labelPosition={labelPosition ? labelPosition : 'left'}
            type={type ? type : 'reset'}
            onClick={setOpen}
            {...rest}
        >
            <Icon name={'arrow right'} />
            {title ? title : t('components.buttons.view')}
        </Button>
    );

};

export default OpenModalButton;
